import { Route, Redirect } from "react-router-dom";

export const RouteWithPermission = ({ path, component: Component, hasPerm }) => (
  <Route
    path={path}
    exact={true}
    render={(props) => (hasPerm ? <Component {...props} /> : <Redirect to='/error/404' />)}
  />
);